import PortalFormModal from './PortalFormModal';

import Attention from '../../ReusableComponents/Attention';

import React from 'react';
import moment from 'moment';
import { usePortalMutation } from '../hooks';

export default function PublicationForm({ selection, item, onDone }) {
  const save = usePortalMutation(
    `selecoes/${selection.id}/editais${item ? '/' + item.id : ''}`,
    item ? 'PUT' : 'POST'
  );
  return (
    <PortalFormModal
      title={item ? 'Editar publicação' : 'Nova publicação'}
      onClose={onDone}
      onSubmit={(e) => {
        e.preventDefault();
        const form = e.currentTarget,
          f = new FormData(form);
        for (const key of ['published_at', 'ends_at'])
          if (f.get(key)) f.set(key, new Date(f.get(key)).toISOString());
        save.mutate(
          item
            ? {
                ...Object.fromEntries(f),
                sort_order: Number(f.get('sort_order')),
                published_at: f.get('published_at') || null,
                ends_at: f.get('ends_at') || null,
              }
            : f,
          {
            onSuccess: () => {
              if (onDone) onDone();
              else form.reset();
            },
          }
        );
      }}
      busy={save.isLoading}
      allowed={save.allowed}
      error={save.error}
    >
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Título
            <Attention />
          </span>
          <input className="form-control" name="title" required defaultValue={item?.title} />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Tipo
            <Attention />
          </span>
          <select
            className="form-control form-select"
            name="type"
            defaultValue={item?.type || 'edital'}
            required
          >
            {[
              ['edital', 'Edital'],
              ['retificacao', 'Retificação'],
              ['comunicado', 'Comunicado'],
              ['resultado', 'Resultado'],
              ['preliminar', 'Resultado preliminar'],
              ['definitivo', 'Resultado definitivo'],
              ['convocacao', 'Convocação'],
              ['cronograma', 'Cronograma'],
              ['outro', 'Outro documento'],
            ].map(([v, t]) => (
              <option key={v} value={v}>
                {t}
              </option>
            ))}
          </select>
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Visibilidade
            <Attention />
          </span>
          <select
            className="form-control form-select"
            name="visibility"
            defaultValue={item?.visibility || 'public'}
            required
          >
            <option value="public">Público</option>
            <option value="registered">Somente inscritos neste seletivo</option>
          </select>
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Ordem
            <Attention />
          </span>
          <input
            className="form-control"
            type="number"
            name="sort_order"
            min={0}
            max={10000}
            defaultValue={item?.sort_order || 0}
            required
          />
        </label>
        {[
          ['published_at', 'Publicar em'],
          ['ends_at', 'Disponível até'],
        ].map(([name, label]) => (
          <label key={name} className="form-label">
            <span className="portal-field-label">
              {label}
              <small className="text-muted">(opcional)</small>
            </span>
            <input
              className="form-control"
              name={name}
              type="datetime-local"
              defaultValue={item?.[name] ? moment(item[name]).format('YYYY-MM-DDTHH:mm') : ''}
            />
          </label>
        ))}
      </div>

      <label className="form-label">
        <span className="portal-field-label">
          Descrição
          <small className="text-muted">(opcional)</small>
        </span>
        <textarea
          name="description"
          className="form-control"
          rows={3}
          defaultValue={item?.description || ''}
        />
      </label>

      {!item && (
        <label className="form-label">
          <span className="portal-field-label">
            Arquivo PDF
            <Attention />
          </span>
          <input name="file" className="form-control" type="file" required accept=".pdf" />
        </label>
      )}
    </PortalFormModal>
  );
}
